import React from "react";
import { useLanguage } from "@/i18n/LanguageContext";
import { useTheme } from "@/theme/ThemeContext";
import { X } from "lucide-react";

/**
 * MoreDrawer — slide-in panel from the right with ≤640px width on desktop,
 * full-screen on mobile. Used by the "Още" (More) navigation menu.
 */
export default function MoreDrawer({ open, title, onClose, children }) {
  const { language } = useLanguage();
  const { isDark } = useTheme();
  const bg = language === "bg";

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[60]" data-testid="more-drawer">
      {/* Backdrop */}
      <button
        type="button"
        aria-label={bg ? "Затвори" : "Close"}
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-sm animate-in fade-in"
        data-testid="more-drawer-backdrop"
      />

      {/* Panel */}
      <div
        className={`absolute right-0 top-0 bottom-0 w-full sm:max-w-[540px] overflow-hidden flex flex-col animate-in slide-in-from-right ${
          isDark ? "bg-[hsl(222,47%,8%)]" : "bg-white"
        }`}
        role="dialog"
        aria-modal="true"
      >
        <div className={`flex items-center justify-between px-4 py-3 border-b ${isDark ? "border-[hsl(223,47%,15%)]" : "border-gray-200"}`}>
          <h2 className={`text-sm font-bold ${isDark ? "text-white" : "text-gray-900"}`} data-testid="more-drawer-title">
            {title}
          </h2>
          <button
            onClick={onClose}
            className={`p-1.5 rounded-lg ${isDark ? "hover:bg-[hsl(223,47%,15%)] text-gray-400" : "hover:bg-gray-100 text-gray-500"}`}
            data-testid="more-drawer-close"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-3 py-4">{children}</div>
      </div>
    </div>
  );
}
